module.exports = __webpack_public_path__ + "img/sun.d5add51e.png";